import { sortBy } from 'lodash';
import { IProductVariation } from 'src/interfaces';

export const sortProductVariation = (
  productVariations?: IProductVariation[],
) => {
  if (productVariations) {
    return sortBy(productVariations, [
      (variation) => {
        const matches = variation.product_code === variation.group_product_code;

        return matches ? 0 : 1;
      },
    ]);
  }

  return productVariations;
};
